import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CreditCardsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        clipRule="evenodd"
        d="M41.7 37H13.1C9.2 37 6 33.9 6 29.9V15.6c0-3.9 3.2-7.1 7.1-7.1h28.6c3.9 0 7.1 3.2 7.1 7.1V30c0 3.9-3.2 7-7.1 7z"
        fill="none"
        fillRule="evenodd"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M36.9 41.9H8.3c-3.9 0-7.1-3.2-7.1-7.1V20.4c0-3.9 3.2-7.1 7.1-7.1h28.6c3.9 0 7.1 3.2 7.1 7.1v14.4c0 3.9-3.2 7.1-7.1 7.1z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        fillRule="evenodd"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M35.6 19c-1.3 0-2.5.7-3.1 1.7-.7-1-1.8-1.7-3.1-1.7-2.1 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7c1.3 0 2.5-.7 3.1-1.7.7 1 1.8 1.7 3.1 1.7 2.1 0 3.7-1.7 3.7-3.7S37.6 19 35.6 19z"
        fill="#E81C30"
        className={styles.accentColor}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.1 29.5h-5c-1 0-1.7-.8-1.7-1.7v-3.3c0-1 .8-1.7 1.7-1.7h5c1 0 1.7.8 1.7 1.7v3.3c0 1-.8 1.7-1.7 1.7zM13.8 24.9H5.4M13.8 27.4H5.4M7.9 22.7v6.8M11.2 22.7v6.8M5.8 32.7h33.5M5.8 36.6h33.5"
        fill="none"
        fillRule="evenodd"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
      />
      <circle cx="16.5" cy="26.1" fill="#00000" className={styles.defaultColor} r=".7" />
      <path
        d="M17.8 24.2s1.5 1.7 0 3.5M19.4 23s2.3 2.7 0 6.2M21.1 22s2.9 3.5 0 8"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.1614"
      />
    </Icon>
  )
}
